import React from "react";
import { Form, Input, Button, message, Card } from "antd";
import { postRequest } from "../api/api"; // Adjust if your helper method is named differently

const ChangePassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

const onFinish = async (values) => {
  setLoading(true);
  try {
    const payload = {
      old_password: values.old_password,
      new_password: values.new_password,
      new_password_confirmation: values.new_password_confirmation,
    };

    const response = await postRequest("change-password", payload);

    // ✅ Handle success
    message.success(response?.message || "Password changed successfully!");
    form.resetFields();
  } catch (error) {
    // ✅ Handle 400 response like {"message":"Old password is incorrect."}
    const apiMessage =
      error?.response?.data?.message || // from backend JSON
      error?.message ||                 // general error message
      "Failed to change password";      // fallback message

    message.error(apiMessage);
  } finally {
    setLoading(false);
  }
};


  return (
    <Card
      title="Change Password"
      style={{ maxWidth: 500, margin: "40px auto" }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Old Password"
          name="old_password"
          rules={[{ required: true, message: "Please enter your old password" }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="New Password"
          name="new_password"
          rules={[
            { required: true, message: "Please enter a new password" },
            { min: 6, message: "Password must be at least 6 characters" },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="Confirm New Password"
          name="new_password_confirmation"
          dependencies={["new_password"]}
          rules={[
            { required: true, message: "Please confirm your new password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Passwords do not match")
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ChangePassword;
